import { render } from "./FeaturedFilter.vue?vue&type=template&id=130db876"
import script from "./FeaturedFilter.vue?vue&type=script&lang=js"
export * from "./FeaturedFilter.vue?vue&type=script&lang=js"

import "./FeaturedFilter.vue?vue&type=style&index=0&id=130db876&lang=css"
script.render = render

export default script